import { render, staticRenderFns } from "./visual-type-graph.vue?vue&type=template&id=6e038f68"
import script from "./visual-type-graph.vue?vue&type=script&lang=js"
export * from "./visual-type-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports